import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@components/base.component';
import { SidebarService } from '@services/sidebar.service';
import { State } from '@app/state';
import { GlobalUtil } from '@app/modules/common/shared/util/global-util';
import { ContactTypeService } from '@services/contact-type.service';

@Component({
  selector: 'app-contact-type-form',
  templateUrl: './contact-type-form.component.html',
  styleUrls: ['./contact-type-form.component.scss'],
  providers: [SidebarService]
})

export class ContactTypeFormComponent extends BaseComponent {

  // Local variables
  contactTypeFormGroup: FormGroup;
  dataLoaded = false;
  globalUtil = GlobalUtil;

  // Contractor
  constructor(
    public activatedRoute: ActivatedRoute,
    public contactTypeService: ContactTypeService,
    public sidebarService: SidebarService,
    public state: State,
    private formBuilder: FormBuilder
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService: sidebarService,
      state: state,
      modelService: contactTypeService
    });

    this.setPageVars({
      sidebar: ''
    });

    this.initialFormGroupSetup();
    const id = this.routeParams['id'];
    if (id === undefined) {
      this.dataLoaded = true;
    } else {
      this.modelService.getOne(id).subscribe((result: any) => {
        this.dataLoaded = true;
        this.contactTypeFormGroup.patchValue(result);
      });
    }
  }

  // All the public methods
  get controls(): any {
    return this.contactTypeFormGroup.controls;
  }

  public save(): void {
    const id = this.controls.id.value;
    const uuid = this.controls.uuid.value;
    if (id || uuid) {
      // Update the existing row
      this.contactTypeService.patchById(uuid ? uuid : id, this.contactTypeFormGroup.value)
        .subscribe(result => {
          this.SavedMessage(result);
        });
    } else {
      // Create the new row
      this.contactTypeService.create(this.contactTypeFormGroup.value).subscribe(result => this.SavedMessage(result));
    }
  }

  public cancel(): void {
    this.contactTypeFormGroup.reset();
  }

  // All the private methods
  private initialFormGroupSetup(): void {
    // setup the initial form for row entity
    this.contactTypeFormGroup = this.formBuilder.group({
      uuid: [null],
      id: [null],
      name: [null, [Validators.required, Validators.maxLength(GlobalUtil.Validation.GENERAL_FIELD_MAX_LENGTH)]]
    });
  }

  private SavedMessage(data) {
    this.state.message({ ['ContactTypeIndexUpdate']: true });
    this.closeSlideout();
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
